export default __webpack_public_path__ + "static/nav-light-2841923717bc2b9e2555424d123f081f.png";